var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitpanelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exitpanelIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-103",
    d: "M20,15.992a1.333,1.333,0,1,0,0,2.666h1.333a5.332,5.332,0,0,0,5.333-5.331v-8A5.332,5.332,0,0,0,21.333,0h-16A5.332,5.332,0,0,0,0,5.331v8a5.332,5.332,0,0,0,5.333,5.331H6.667a1.333,1.333,0,1,0,0-2.666H5.333a2.666,2.666,0,0,1-2.667-2.666v-8A2.666,2.666,0,0,1,5.333,2.666h16A2.666,2.666,0,0,1,24,5.331v8a2.666,2.666,0,0,1-2.667,2.666Z",
    transform: "translate(2.676 29.333) rotate(-90)",
    fill: "#fff",
    opacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 2.667,
    height: 16,
    rx: 1,
    transform: "translate(26.667 14.667) rotate(90)",
    fill: "#fff",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-104",
    d: "M8.391.391a1.333,1.333,0,1,1,1.886,1.886l-4,4a1.333,1.333,0,0,1-1.886,0l-4-4A1.333,1.333,0,1,1,2.276.391L5.333,3.448Z",
    transform: "translate(22.667 21.333) rotate(-90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitpanelIcon);
export default __webpack_public_path__ + "static/media/exitpanelIcon.d934759ead052e2d40ad9548304e2061.svg";
export { ForwardRef as ReactComponent };